import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import Content from '../../../common/Content';
import GridCharts from '../../../content/grid/GridCharts';
import Twenty from './Twenty';

import LinkRoute from '../../../route/LinkRoute';
// import SearchRoute from '../../../route/SearchRoute';
import PlaylistRoute from '../../../route/PlaylistRoute';
import HistoryRoute from '../../../route/HistoryRoute';
import Faq from '../../../views/Faq';
import Collection from '../../../views/Collection';
import CartRoute from '../../../cart/CartRoute';

import GridPlaylists from '../../../content/grid/GridPlaylists';
import GridArtists from '../../../content/grid/GridArtists';
import GridLabels from '../../../content/grid/GridLabels';
import ListV2 from '../../../content/list/ListV2';
// import ListSearchTracks from '../../../content/list/ListSearchTracks';

/* CUSTOM MODS */
import PartyModeRoute from '../../../partymode/PartyModeRoute';
import Playlists from '../mods/playlists/Container';

function ConnectedCustomRoute({ width, height }) {
  return (
    <>
      <LinkRoute />
      {/* <SearchRoute /> */}
      <PlaylistRoute />
      <HistoryRoute />
      <CartRoute />
      <PartyModeRoute />
      <Switch>
        <Route path="/the20">
          <Twenty />
        </Route>
        <Route path="/featured-playlists">
          <Playlists />
        </Route>
        <Route path="/featured-playlists-v1" render={() => {
          if (document.getElementById(`cm-v2`)) {
            document.getElementById(`cm-v2`).scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
          return (
            <>
              <GridCharts title={`The20`} id={`{A}The20`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/the20`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=46095` }
                className={`grid-chart new-playlists`}
              />
              <GridCharts title={`Monthly Top Picks`} id={`{B}monthly-top-picks`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/monthly-top-picks`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=47907` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Club Sets`} id={`{C}Club_Sets`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/club-sets`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48298` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Learn-To-Mix`} id={`{D}learn-to-mix`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/learn-to-mix`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48301` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Weddings`} id={`{E}Weddings`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/weddings`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48309` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`New Hits & Must-Haves`} id={`{F}New Hits & Must-Haves`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/new_hits_must_haves`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48295` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Open Format Sets`} id={`{G}Open-Format-Sets`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/open_format_sets`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=112803` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Decades Collections`} id={`{H}Decades-Collections`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/decades_collections`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48333` }
                className={`grid-chart beatx`}
              />         
              {/* <GridCharts title={`Acapellas`} id={`{G}beatsource_acapellas_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/acapellas`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48362` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Featured Playlists`} id={`{H}beatsource_bs_playlists_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/playlists`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=92` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Global Sounds`} id={`{I}beatsource_global_sounds_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/global-sounds`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48307` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Holiday`} id={`{J}beatsource_holiday_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/holidays`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48398` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Instrumentals`} id={`{K}beatsource_instrumentals_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/instrumentals`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48359` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Labels & Crews`} id={`{L}beatsource_labels_crews_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/labels-crews`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48430` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Link Essentials`} id={`{M}beatsource_link_essentials_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/link-essentials`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48305` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`ROAD Podcast`} id={`{O}beatsource_road_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/road-podcast`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48395` }
                className={`grid-chart beatx`}
              />
              <GridCharts title={`Verzuz Battles`} id={`{P}beatsource_battles_slice`}
                width={width} rowCount={1} height={ ((Config.CARD_HEIGHT + Config.GRID_PAD)) + Config.GRID_COVER_PAD }
                hasPagination={true} allTo={`/bs/verzuz-battles`}
                arrowLeftStyle={{ position: `absolute`, right: width, bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }} arrowRightStyle={{ position: `absolute`, right: (Config.CHART_PAD * -1), bottom: (Config.CARD_HEIGHT - Config.GRID_PAD) * -1 }}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=48392` }
                className={`grid-chart beatx`}
              /> */}
            </>
          );
        }} />

        <Route path="/bs/the20">
          <Content name={`The20`}>
            <GridCharts id={`The20`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=46095` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>


        <Route path="/bs/weddings">
          <Content name={`Weddings`}>
            <GridCharts id={`beatsource_weddings`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48309` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/road-podcast">
          <Content name={`ROAD Podcast`}>
            <GridCharts id={`beatsource_road-podcast`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48395` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/instrumentals">
          <Content name={`Instrumentals`}>
            <GridCharts id={`beatsource_instrumentals`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48359` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/global-sounds">
          <Content name={`Global Sounds`}>
            <GridCharts id={`beatsource_global_sounds`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48307` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/decades_collections">
          <Content name={`Decades Collections`}>
            <GridCharts id={`decades_collections`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48333` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/playlists">
          <Content name={`Featured Playlists`}>
            <GridCharts id={`charts_bs`} width={width}
              hasFilters={false} buttonFilterStyle={{ top: 12 }} filtersStyle={{ top: 43, height: 250 }}
              height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=92`}
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true}
            />
          </Content>
        </Route>
        <Route path="/bs/vip-crates">
          <Content name={`VIP Crates`}>
            <GridCharts id={`beatsource_vip_crates`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=42992` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/holidays">
          <Content name={`Holidays`}>
            <GridCharts id={`beatsource_holidays`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48398` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/100P">
          <Content name={`100%`}>
            <GridCharts id={`beatsource_100p`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=47908` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/produced-by">
          <Content name={`Produced By`}>
            <GridCharts id={`beatsource_produced_by`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=47910` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/club-sets">
          <Content name={`Club Sets`}>
            <GridCharts id={`beatsource_club_sets`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48298` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/learn-to-mix">
          <Content name={`Learn To Mix`}>
            <GridCharts id={`beatsource_learn_to_mix`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48301` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/link-essentials">
          <Content name={`Link Essentials`}>
            <GridCharts id={`beatsource_link_essentials_mix`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48305` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/1980s">
          <Content name={`1980s`}>
            <GridCharts id={`beatsource_1980s`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48335` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/1990s">
          <Content name={`1990s`}>
            <GridCharts id={`beatsource_1990s`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48338` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/2000s">
          <Content name={`2000s`}>
            <GridCharts id={`beatsource_2000s`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48341` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/2010s">
          <Content name={`2010s`}>
            <GridCharts id={`beatsource_2010s`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48354` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/2020s">
          <Content name={`2020s`}>
            <GridCharts id={`beatsource_2020s`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48356` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/acapellas">
          <Content name={`acapellas`}>
            <GridCharts id={`beatsource_acapellas`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48362` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/labels-crews">
          <Content name={`Labels & Crews`}>
            <GridCharts id={`beatsource_labels-crews`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48430` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/verzuz-battles">
          <Content name={`Verzuz Battles`}>
            <GridCharts id={`beatsource_verzuz-battles`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48392` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/monthly-top-picks">
          <Content name={`Monthly Top Picks`}>
            <GridCharts id={`beatsource_monthly_top_picks`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=47907` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/samples-series">
          <Content name={`Samples Series`}>
            <GridCharts id={`beatsource_samples_series`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=47911` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/new_hits_must_haves">
          <Content name={`New Hits & Must-Haves`}>
            <GridCharts id={`new_hits_must_haves`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=48295` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>
        <Route path="/bs/open_format_sets">
          <Content name={`Open Format Sets`}>
            <GridCharts id={`open_format_sets`}
              width={width} height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&owner_id=112803` }
              style={{marginTop: 20}} className={`grid-chart`} showLoading={true} />
          </Content>
        </Route>

        <Route path="/FAQ">
          <Faq />
        </Route>

        <Route path="/search/artists/:value" render={ props => (
          <Content name={`Artist Results`}>
            <GridArtists id={`search-artists-${props.match.params.value}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/search/?per_page=40&type=artists&q=${props.match.params.value}`}
              isBaseRootApi={true}
              style={{marginTop: 20}}
            />
          </Content>
        )} />
        <Route path="/search/labels/:value" render={ props => (
          <Content name={`Label Results`}>
            <GridLabels id={`search-labels-${props.match.params.value}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4) }
              perPage={100} pathApi={`/catalog/search/?per_page=40&type=labels&q=${props.match.params.value}`}
              isBaseRootApi={true}
              style={{marginTop: 20}}
            />
          </Content>
        )} />
        <Route path="/search/playlists/:value" render={ props => (
          <Content name={`Playlist Results`}>
            <GridCharts id={`search-playlists-${props.match.params.value}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 3) }
              perPage={100} pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&name=${props.match.params.value}`}
              style={{marginTop: 20}}
            />
          </Content>
        )} />
        <Route path="/search/playlists/" render={ props => (
          <Content name={`Playlist Results`}>
            <GridPlaylists id={`search-playlists-${props.match.params.value}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 3) }
              perPage={100} pathApi={`/charts?count=100&is_approved=true`}
              style={{marginTop: 20}}
            />
          </Content>
        )} />
      <Route path="/search/tracks/:value" render={ props => (
        <ListV2
          title={`Track Results`}
          titleClassName={`title-border-bottom`}
          pathApi={`/catalog/search/?q=${props.match.params.value}&type=tracks&per_page=50`  /*`/catalog/tracks?name=${props.match.params.value}&per_page=100`*/}
          sortable={false}
          id={`search-tracks-${props.match.params.value}`}
          width={width}
          height={height - (Config.TAB_BAR_GUTTER * 2.5)}
          size={Config.LIST_ROW_HEIGHT}
          style={{marginTop: 0}}
          filtersStyle={{position: `absolute`, top: 13, right: 0}}
          panelStyle={{margin: `8px 0px 16px 0px`}}
          isLoadMore={false}
          type={`Full`}
          orderBy={[`title`, `label`, `genre_s`, `release`]}
          filters={[`mix_name`, `artists_s`, `label`, `genre_s`, `bpm`, `key_convert`]}
        />
      )} />

        <Route path="/collection">
          <Collection />
        </Route>

      </Switch>
    </>
  );
}

const CustomRoute = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedCustomRoute);

export default CustomRoute;
